import { z } from 'zod'

export const ContactSchema = z
	.object({
		name: z.string(),
		surname: z.string(),
		address1: z.string().optional(),
		address2: z.string().optional(),
		city: z.string(),
		zip: z.string().optional(),
		country: z.string(),
		province: z.string().optional(),
		phone: z.string().optional(),
		reasonForContact: z.string(), // leadType for the italian CRM
		email: z.string(),
		profession: z.string(),
		company: z.string().optional(),
		message: z.string(),
		acceptsTerms: z.boolean(),
		newsletter: z.boolean().optional(),
		timestamp: z.string(), // Time-based validation to prevent bot spam
	})
	.superRefine((schema, ctx) => {
		const { country, province } = schema

		// Province is optional unless country is IT or US
		if ((country === 'IT' || country === 'US') && !province) {
			// Add error to province
			ctx.addIssue({
				path: ['province'],
				code: 'custom',
				message: 'Province is required for Italy and United States.',
			})
		}
	})
